import { useEffect } from 'react'
import { useResetRecoilState } from 'recoil'
import styled from 'styled-components'

import SubScript from '@/shared/components/common/Subscript/SubScript'
import { CertNumState, TelNumState, TimeOutState, TranIdState } from '@/shared/store'
import { customMedia } from '@/styles/common/common'

const CancelPage = () => {
  const ResetTelNum = useResetRecoilState(TelNumState)
  const ResetTimeOut = useResetRecoilState(TimeOutState)
  const ResetTranId = useResetRecoilState(TranIdState)
  const ResetCertNum = useResetRecoilState(CertNumState)

  useEffect(() => {
    return () => {
      ResetTelNum()
      ResetTimeOut()
      ResetCertNum()
      ResetTranId()
    }
  }, [ResetCertNum, ResetTelNum, ResetTimeOut, ResetTranId])

  /*20231024 lgu+ 가입/해지 불가 모달*/
  /*const [open, setOpen] = useState(true)
    const {flag} = useNoticeModal("2023-10-16 00:00:00", "2023-10-23 08:00:00")
    useEffect(() => {
        if (open && flag()) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
    }, [flag, open])*/
  return (
    <>
      {/*20231024 lgu+ 가입/해지 불가 모달*/}
      {/*{flag() && <Modal isOpen={open} toggle={() => setOpen(!open)} type={'notice'} ClickFunc={() => setOpen(!open)}/>}*/}
      <CancelWrap>
        <SubScript />
      </CancelWrap>
    </>
  )
}
export default CancelPage

const CancelWrap = styled.div`
  display: block;
  margin-bottom: 240px;
  ${customMedia.lessThan('mobile')`
    margin-bottom: 124px;
  `}
`
